import React, { useEffect, useState } from "react";
import { Input, Select, Switch, Row, Col, Card, Button, message } from "antd";
import { ReloadOutlined, PlusOutlined, CloseOutlined } from "@ant-design/icons";
import Layout from "Layout";
import { useParams, useNavigate } from "react-router-dom";
import { mixGetV1, mixPostV1, mixPutV1 } from "services/mixin";

const { Option } = Select;

const ServicePackageForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    slug: "",
    price: "",
    commission: "",
    duration: "",
    unlimited: false,
    uses: "",
    usedays: "",
    user: "",
    priceId: "",
    productId: "",
    bundleId: "",
    isActive: true,
  });

  const [contentData, setContentData] = useState({
    val0: 0,
    val1: "",
    val2: "",
    val3: "",
    val5: [],
  });

  useEffect(() => {
    if (id) {
      setIsEdit(true);
      loadDetail();
    }
  }, [id]);

  const loadDetail = async () => {
    setLoading(true);
    try {
      const res = await mixGetV1(`/api/v1/be/package/${id}`);

      if (res?.status) {
        const d = res.data;

        setForm({
          name: d.name,
          slug: d.slug,
          price: d.price,
          commission: d.affiliate_commission,
          duration: d.day,
          unlimited: d.is_unlimit === 1,
          uses: d.number_of_use,
          usedays: d.number_lifetime,
          user: d.turn,
          priceId: d.price_id_stripe,
          productId: d.bundle_id_accesstrade,
          bundleId: d.product_id_accesstrade,
          isActive: d.is_active === 1,
        });

        if (d.content) {
          try {
            const parsed = JSON.parse(d.content);
            setContentData({
              val0: parsed.val0 || 0,
              val1: parsed.val1 || "",
              val2: parsed.val2 || "",
              val3: parsed.val3 || "",
              val5: parsed.val5 || [],
            });
          } catch (e) {
            console.log("ERROR parsing content:", e);
          }
        }
      }
    } catch (e) {
      console.log("ERROR DETAIL:", e);
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    const payload = {
      name: form.name,
      slug: form.slug,
      price: form.price,
      affiliate_commission: form.commission,
      day: Number(form.duration) || 0,
      is_unlimit: form.unlimited ? 1 : 0,
      number_of_use: form.uses || 0,
      turn: form.user,
      price_id_stripe: form.priceId,
      product_id_accesstrade: form.productId,
      bundle_id_accesstrade: form.bundleId,
      number_lifetime: form.usedays,
      is_active: form.isActive ? 1 : 0,
      content: JSON.stringify(contentData),
    };

    try {
      let res;

      if (isEdit) {
        res = await mixPutV1(`/api/v1/be/package/${id}`, payload);
      } else {
        res = await mixPostV1("/api/v1/be/package", payload);
      }

      if (res?.status) {
        message.success(isEdit ? "Cập nhật thành công!" : "Thêm mới thành công!");
        navigate("/goi-dich-vu");
      }
    } catch (err) {
      message.error("Có lỗi xảy ra!");
    }
  };

  const addDetail = () => {
    const newId = Math.random().toString(36).substr(2, 6);
    setContentData({
      ...contentData,
      val5: [...contentData.val5, { id: newId, val1: "" }],
    });
  };

  const removeDetail = (index) => {
    const newList = contentData.val5.filter((_, i) => i !== index);
    setContentData({ ...contentData, val5: newList });
  };

  const updateDetail = (index, value) => {
    const newList = [...contentData.val5];
    newList[index].val1 = value;
    setContentData({ ...contentData, val5: newList });
  };

  return (
    <Layout>
      <div style={{ padding: 24 }}>
        <h2 style={{ fontSize: 26, marginBottom: 16 }}>
          {isEdit ? "Chỉnh sửa gói dịch vụ" : "Thêm gói dịch vụ"}
        </h2>

        <Card title="Thông tin đặt hàng" bordered={false} loading={loading}>
          <Row gutter={20}>
            <Col span={12}>
              <label>Tên</label>
              <Input
                value={form.name}
                onChange={(e) => {
                  const nameValue = e.target.value;
                  const slugValue = nameValue
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9\s-]/g, "")
                    .replace(/\s+/g, "-");

                  setForm({ ...form, name: nameValue, slug: slugValue });
                }}
              />
            </Col>

            <Col span={12}>
              <label>Slug</label>
              <Input
                value={form.slug}
                prefix={<ReloadOutlined />}
                onChange={(e) => setForm({ ...form, slug: e.target.value })}
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Giá</label>
              <Input
                suffix="VND"
                value={form.price}
                onChange={(e) => setForm({ ...form, price: e.target.value })}
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Hoa hồng</label>
              <Input
                suffix="%"
                value={form.commission}
                onChange={(e) =>
                  setForm({ ...form, commission: e.target.value })
                }
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Thời hạn</label>
              <Select
                placeholder="Chọn thời hạn"
                style={{ width: "100%" }}
                value={form.duration}
                onChange={(v) => {
                  if (v === "unlimited") {
                    setForm({
                      ...form,
                      duration: 0,
                      unlimitedSwitch: false,
                      uses: "",
                    });
                  } else {
                    setForm({
                      ...form,
                      duration: v,
                      unlimitedSwitch: false,
                    });
                  }
                }}
              >
                <Option value="30">Một tháng</Option>
                <Option value="365">Một năm</Option>
                <Option value="unlimited">Vô thời hạn</Option>
              </Select>
            </Col>

            {form.duration !== 0 && (
              <>
                <Col span={8} style={{ marginTop: 20 }}>
                  <label>Không giới hạn sử dụng</label>
                  <br />
                  <Switch
                    checkedChildren="✔"
                    unCheckedChildren="✖"
                    checked={form.unlimitedSwitch}
                    onChange={(checked) =>
                      setForm({
                        ...form,
                        unlimitedSwitch: checked,
                        uses: checked ? "" : form.uses,
                      })
                    }
                  />
                </Col>

                <Col span={8} style={{ marginTop: 20 }}>
                  <label>Số lần sử dụng</label>
                  <Input
                    disabled={form.unlimitedSwitch}
                    value={form.uses}
                    onChange={(e) => setForm({ ...form, uses: e.target.value })}
                  />
                </Col>
              </>
            )}

            {form.duration === 0 && (
              <Col span={8} style={{ marginTop: 20 }}>
                <label>Số lần sử dụng / tháng</label>
                <Input
                  value={form.usedays}
                  onChange={(e) => setForm({ ...form, usedays: e.target.value })}
                />
              </Col>
            )}

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Số user</label>
              <Input
                value={form.user}
                onChange={(e) => setForm({ ...form, user: e.target.value })}
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Price ID</label>
              <Input
                value={form.priceId}
                onChange={(e) => setForm({ ...form, priceId: e.target.value })}
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Product id accesstrade</label>
              <Input
                value={form.productId}
                onChange={(e) =>
                  setForm({ ...form, productId: e.target.value })
                }
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Bundle id accesstrade</label>
              <Input
                value={form.bundleId}
                onChange={(e) =>
                  setForm({ ...form, bundleId: e.target.value })
                }
              />
            </Col>

            <Col span={8} style={{ marginTop: 20 }}>
              <label>Active</label>
              <br />
              <Switch
                checkedChildren="✔"
                unCheckedChildren="✖"
                checked={form.isActive}
                onChange={(v) => setForm({ ...form, isActive: v })}
              />
            </Col>
          </Row>

        </Card>

        <Card
          title="Thông tin hiện thị"
          bordered={false}
          style={{ marginTop: 24 }}
        >
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 8, color: "#010101ff" }}>
              Nổi bật
            </label>
            <Switch
              checkedChildren="✔"
              unCheckedChildren="✖"
              checked={contentData.val0 === 1}
              onChange={(checked) =>
                setContentData({ ...contentData, val0: checked ? 1 : 0 })
              }
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 8, color: "#010101ff" }}>
              Tên gói
            </label>
            <Input
              value={contentData.val1}
              onChange={(e) =>
                setContentData({ ...contentData, val1: e.target.value })
              }
              style={{ borderRadius: 4 }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 8, color: "#010101ff" }}>
              Giá
            </label>
            <Input
              value={contentData.val2}
              onChange={(e) =>
                setContentData({ ...contentData, val2: e.target.value })
              }
              style={{ borderRadius: 4 }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", marginBottom: 8, color: "#010101ff" }}>
              Mô tả ngắn
            </label>
            <Input
              value={contentData.val3}
              onChange={(e) =>
                setContentData({ ...contentData, val3: e.target.value })
              }
              style={{ borderRadius: 4 }}
            />
          </div>

          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={addDetail}
                style={{ borderRadius: 4 }}
              >
                Thêm
              </Button>
              <span style={{ color: "#010101ff" }}>Chi tiết</span>
            </div>

            {contentData.val5.map((item, index) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  gap: 8,
                  marginBottom: 8,
                  alignItems: "center",
                }}
              >
                <Input
                  value={item.val1}
                  onChange={(e) => updateDetail(index, e.target.value)}
                  style={{ flex: 1, borderRadius: 4 }}
                />
                <Button
                  icon={<PlusOutlined />}
                  style={{ borderRadius: 4 }}
                  onClick={addDetail}
                />
                <Button
                  icon={<CloseOutlined />}
                  danger
                  style={{ borderRadius: 4 }}
                  onClick={() => removeDetail(index)}
                />
              </div>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24 }}>
            <Button
              type="primary"
              onClick={handleSubmit}
            >
              {isEdit ? "Cập nhật" : "Thêm mới"}
            </Button>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default ServicePackageForm;